// Module
var code = `<div class="actions">
	<div class="pull-sm-left">
		<div class="btn-group">
			<div class="search input-group">
				<!-- ko if:  \$data.listFilters && ko.utils.unwrapObservable(\$data.listFilters).length > 0 -->
				<div class="input-group-btn dropdown">
					<button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" data-bind="text: listFilter().name" id="list-filter-dropdown"></button>
					<ul class="dropdown-menu" data-bind="foreach: listFilters">
						<!-- ko if: \$data.header -->
						<li class="dropdown-header" data-bind="text: header"></li>
						<!-- /ko -->
						<!-- ko if: \$data.separator -->
						<li class="dropdown-divider"></li>
						<!-- /ko -->
						<!-- ko ifnot: (\$data.separator || \$data.header) -->
						<li>
							<a class="dropdown-item" href="#" data-bind="text: name, click: \$root.changeListFilter"></a>
						</li>
						<!-- /ko -->
					</ul>
				</div>
				<!-- /ko -->
				<div class="disconnected-search">
					<input type="text" class="form-control" placeholder="Search" aria-label="Search" data-bind="textInput: \$root.search">
				</div>
			</div>
		</div>

		<!-- ko if: \$data.showAdvancedFilter -->
		<div class="btn-group">
			<label class="btn btn-secondary" style="margin-bottom: 0" data-bind="css:{ active: \$data.advancedFilter }" aria-label="Show advanced filters" for="advancedFilters">
				<input type="checkbox" class="hidden-a11y" data-bind="checked: \$data.advancedFilter" id="advancedFilters" aria-hidden><i class="fa fa-sliders"></i>
			</label>
		</div>
		<!-- /ko -->
	</div>
	<div class="pull-sm-right">
		<!-- ko if: \$data.listView && \$data.listView().selectable -->
		<div class="btn-group dropdown" data-bind="visible: listView() && listView().selectable && listView().selectedAny && listView().hasBulkActions()">
			<button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" data-bind="click: clickedBulkActions">
				Bulk actions
			</button>
			<ul class="dropdown-menu" data-bind="foreach: {data: listView().actions, afterRender: \$root._bindTooltips }">
				<!-- ko if: \$data.header -->
				<li class="dropdown-header" data-bind="text: name"></li>
				<!-- /ko -->
				<!-- ko if: \$data.divider -->
				<li class="dropdown-divider"></li>
				<!-- /ko -->
				<!-- ko ifnot: \$data.divider || \$data.header -->
				<li>
					<a class="dropdown-item" href="#" data-bind="
					css: {disabled: \$data.disabledBulk(\$data, \$root.listView().getSelected()) },
					click: function(){ 
						if(\$data.disabledBulk(\$data, \$root.listView().getSelected())) return;

						\$data.clickedBulk(\$data, \$root.listView().getSelected()) 
					}">
						<div style="display: flex; flex: 1; justify-content: space-between; align-items: center">
							<span data-bind="text: \$data.getNameBulk(\$data, \$root.listView().getSelected())"></span>
							<!-- ko if: \$data.showTooltipBulk?.(\$data, \$root.listView().getSelected()) -->
							<i class="fa fa-question-circle-o" data-toggle="tooltip" data-placement="right" data-bind="attr: { title: \$data.getTooltipBulk(\$data, \$root.listView().getSelected()) }"></i>
							<!-- /ko -->
						</div>
					</a>
				</li>
				<!-- /ko -->
			</ul>
		</div>
		<!-- /ko -->
		<!-- ko if: \$data.listSorts && ko.utils.unwrapObservable(\$data.listSorts).length > 1 -->
		<div class="btn-group dropdown">
			<button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown">Sort</button>
			<div class="dropdown-menu dropdown-menu-right">
				<ul class="list-unstyled" style="max-height: 200px; overflow: auto">
					<!-- ko foreach: listSorts -->
					<!-- ko if: \$data.divider -->
					<li class="dropdown-divider"></li>
					<!-- /ko -->
					<!-- ko ifnot: \$data.divider -->
					<li data-bind="css:{ selected: name == (\$root.listSort()?\$root.listSort().name:'') }">
						<a class="dropdown-item" href="#" data-bind="text: name, click: \$root.changeListSort"></a>
					</li>
					<!-- /ko -->
					<!-- /ko -->
				</ul>
				<div class="dropdown-divider"></div>
				<div data-bind="css:{ selected: \$root.listSortOrder() == '' }">
					<a class="dropdown-item" href="javascript:void(0);" data-bind="click: function(){ \$root.listSortOrder(''); \$root.changeListSort(\$data) }">Ascending</a>
				</div>
				<div data-bind="css:{ selected: \$root.listSortOrder() == '-' }">
					<a class="dropdown-item" href="javascript:void(0);" data-bind="click: function(){  \$root.listSortOrder('-'); \$root.changeListSort(\$data); }">Descending</a>
				</div>
			</div>
		</div>
		<!-- /ko -->
		<!-- ko if: \$data.listViews && \$data.listViews.length > 1 -->
		<div class="btn-group" data-bind="foreach: listViews">
			<button type="button" class="btn btn-secondary" data-bind="click: \$root.changeListView, css: { active: \$root.listView().name == name }, attr: { 'aria-label' : 'Change view to ' + name}">
				<i class="fa" data-bind="css: icon"></i>
			</button>
		</div>
		<!-- /ko -->
		<!-- Show trigger on all table and item views except the item categories, locations, and usersyncs view. -->
		<!-- ko if: \$root.listView() && \$root.listView().parent && \$root.listView().parent.id !== 'categories' && \$root.listView().parent.id !== 'locations' && \$root.listView().parent.id !== 'usersyncs' -->
		<div style="display: inline-block; vertical-align: middle" data-bind="
				react: {
					component: CustomizeOverview,
					props: {
						fields: \$root.listView().selectedFields(),
						selectedColumns: \$root.listView().selectedFieldIds(),
						saveSelectedColumns: (selectedIds) => {
							\$root.listView().selectedFieldIds(selectedIds);
							\$root.listView()._saveToStorage();
						},
						type: \$root.listView().parent.id,
						viewType: \$root.listView().id,
					}
				}
			"></div>
		<!-- /ko -->
	</div>
</div>
`;
// Exports
export default code;